
import moment from 'moment/min/moment.min';
import numeral from 'numeral';
import './extensions/finch';

window.moment = moment;
window.numeral = numeral;
